<template>
    <div class="email-not-synced">
        <!-- left column content -->
        <div class="email-not-synced__content-wrapper">
            <div>
                <img src="/ressources/logged/img/illustrations/no-email-connected.svg" />
            </div>
            <div class="email-not-synced__content">
                <h3 class="email-not-synced__title">
                    {{ $l10n.__('Envoyez et recevez vos emails dans Sellsy') }}
                </h3>
                <p class="email-not-synced__subtitle">
                    {{
                        $l10n.__(
                            'Centralisez vos emails pour un suivi idéal et afin de profiter pleinement des fonctionnalités associées comme la consultation des coordonnées d’un contact, l’envoi programmé d’email, la création de tâches ou d’événements liés et bien plus encore !',
                        )
                    }}
                </p>
            </div>
        </div>
        <!-- right column action -->
        <div>
            <router-link v-if="isAdmin || !isEmailsSentFromCorp" :to="{ name: 'onboarding.email' }">
                <CompassButton :label="$t.__('email.configure_email_service')" />
            </router-link>
        </div>
    </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import EmailSettingAccountSynced from './EmailSettingAccountSynced.vue';

const { mapState: mapStateUser } = createNamespacedHelpers('user');

export default {
    name: 'EmailSettingAccountNotSynced',
    components: {
        EmailSettingAccountSynced,
    },
    props: {
        isEmailsSentFromCorp: {
            type: Boolean,
            required: true,
        },
    },
    computed: {
        ...mapStateUser({
            isAdmin: 'isAdmin',
        }),
    },
};
</script>
<style lang="scss" scoped>
.email-not-synced {
    border-radius: 4px;
    background: var(--colors-common-background-subtle, #f6f6f9);
    padding: var(--spacing-3);
    display: flex;
    align-items: center;
    justify-content: space-between;

    &__content {
        margin-left: var(--spacing-3);
    }

    &__content-wrapper {
        display: flex;
        align-items: center;
        max-width: 80%;
    }

    &__title {
        margin: 0;
    }

    &__subtitle {
        margin-top: var(--spacing-0);
        margin-bottom: 0;
        color: var(--colors-common-text-subtle-default);
    }
}
</style>
